import { createIdSlice } from '../utils/action/createElementSlice';
export const StyleState = createIdSlice({
    elementName: 'style',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
    },
});
